'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import useEmblaCarousel from 'embla-carousel-react';
import { useCallback, useEffect, useState } from 'react';
import { Image } from '@/components/client';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { useMediaQuery } from '@/hooks/useMediaQuery';
interface HeroImageProps {
  heroImageUrlList: string[];
  adultYN: boolean;
}
export const HeroImage = t0 => {
  const $ = _c(25);
  const {
    heroImageUrlList,
    adultYN
  } = t0;
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  const [selectedIndex, setSelectedIndex] = useState(0);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      loop: true,
      align: "start"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t1);
  let t2;
  if ($[1] !== emblaApi) {
    t2 = () => {
      if (!emblaApi) {
        return;
      }
      setSelectedIndex(emblaApi.selectedScrollSnap());
    };
    $[1] = emblaApi;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onSelect = t2;
  let t3;
  let t4;
  if ($[3] !== emblaApi || $[4] !== onSelect) {
    t3 = () => {
      if (!emblaApi) {
        return;
      }
      onSelect();
      emblaApi.on("select", onSelect);
      return () => {
        emblaApi.off("select", onSelect);
      };
    };
    t4 = [emblaApi, onSelect];
    $[3] = emblaApi;
    $[4] = onSelect;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== adultYN || $[8] !== heroImageUrlList || $[9] !== isDesktopViewport) {
    let t6;
    if ($[11] !== adultYN || $[12] !== isDesktopViewport) {
      t6 = (url, index) => <div key={index} className="relative aspect-square min-w-0 flex-[0_0_100%]">{!isDesktopViewport || index === 0 ? <Image src={url} alt={"\uB2F5\uB840\uD488 \uD788\uC5B4\uB85C\uC774\uBBF8\uC9C0"} fill={true} sizes="(max-width: 768px) 100vw, 500px" className="object-cover" loading="lazy" preload={index === 0} /> : <Skeleton className="absolute size-full" />}{adultYN && <div className="absolute left-20 top-20 rounded-xsmall bg-B-500 px-12 py-4 font-600 text-Gray-white typo-body4">19세이상 구매가능</div>}</div>;
      $[11] = adultYN;
      $[12] = isDesktopViewport;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    t5 = heroImageUrlList.map(t6);
    $[7] = adultYN;
    $[8] = heroImageUrlList;
    $[9] = isDesktopViewport;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = <div className="flex">{t5}</div>;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== emblaRef || $[17] !== t6) {
    t7 = <div className="overflow-hidden" ref={emblaRef}>{t6}</div>;
    $[16] = emblaRef;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== heroImageUrlList.length || $[20] !== selectedIndex) {
    t8 = heroImageUrlList.length > 1 && <div className="absolute bottom-16 right-16 w-fit rounded-pill bg-Gray-black/20 px-8 py-2 font-600 text-Gray-white typo-caption2">{selectedIndex + 1} / {heroImageUrlList.length}</div>;
    $[19] = heroImageUrlList.length;
    $[20] = selectedIndex;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t7 || $[23] !== t8) {
    t9 = <div className="relative w-full">{t7}{t8}</div>;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};